import { pxToRem } from '@packages/themes/utils';
import { makeStyles } from '@/styles/v4/tss-react';

const useStyles = makeStyles({ name: 'CheckoutFormFields' })(
  ({ breakpoints, spacing, typography }) => ({
    section: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(1),
    },
    row: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0, 1fr)',
      gap: spacing(1),
    },
    twoColumns: {
      [breakpoints.up('md')]: {
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
      },
    },
    threeColumns: {
      [breakpoints.up('md')]: {
        gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
      },
    },
    stateDropdown: {
      '& label': {
        ...typography.bodyMd,
        marginBottom: pxToRem(6),
      },
    },
  })
);

export default useStyles;
